const messages = {
  title: "Mediakits & logo’s",
  title_media: "Mediakits & logo’s",
  description:
    "Onze mediabank biedt een ruime selectie content van de Bridgestone- en Firestone-merken, evenals andere groepsoplossingen.  \n" +
    "Gebruik de verschillende filters of voer een gerichte zoekopdracht uit om snel de gewenste content te vinden.  ",
  short_description:
    "Hier vindt u content voor sociale media, POS-materiaal en meer.",
  mediaCategories: {
    products: "Producten",
    brand_and_solutions: "Merken & oplossingen",
    season_and_promotions: "Seizoen & promoties",
    format: "Formaat",
    cars_and_vans: "Personenwagen, SUV, bestelwagen",
    truck_and_buses: "Vrachtwagen & bus",
    motorcycle: "Motorfiets",
    agriculture: "Landbouw",
    construction_machinery: "Bouwmachines",
    bridgestone: "Bridgestone",
    firestone: "Firestone",
    bandag: "Bandag",
    bleetcare: "Fleetcare",
    webfleet: "Webfleet",
    material: "Materialen",
    brochures: "Productbrochures",
    price_list: "Prijslijsten",
    materials: "Materialen",
    video_in_store: "Video met ondertitels",
    video_online: "Video zonder ondertitels",
    video: "Video",
    banner_website: "Banner",
    banner_social_media: "Sociale media",
    logos: "Logo’s",
    summer: "Zomer",
    winter: "Winter",
    all_season: "Alle seizoenen",
    promotions: "Promoties",
    price: "Pricat",
  },
  mediasPage: {
    title: "MEDIATHEEK",
    description:
      "Welkom in de mediasectie gewijd aan   \n" +
      "producten van Bridgestone en Firestone. <br> <br>  \n" +
      "Hier vindt u productbeelden, logo’s, evenals   \n" +
      "een ruime selectie banners, video’s en visuals   \n" +
      "om te gebruiken op uw website of sociale   \n" +
      "media.",
    bDrive: {
      title: "Productfoto’s  ",
      description:
        "De meest recente beelden kunnen worden gedownload via ons B-DRIVE-portaal.",
    },
  },
  buttons: {
    media: "Ontdek meer",
  },
  searchMedia: "Voer trefwoord in",
  searchResults: "Zoekresultaten",
};

export default {
  messages,
};
